<template>
    <FormSection title="Service Location" type="his-section" :full-height="false" :application-id="application">
        <template #content>
            <div class="d-flex flex-column px-3 py-2">
                <AddServiceLocationForm
                    v-if="showServiceForm"
                    :service="newServiceForm"
                    :showServiceForm="showServiceForm"
                    :application="application"
                    :reset-list="resetList"
                    :closeServiceForm="closeServiceForm"
                    ref="serviceLocationForm"
                    style="margin-bottom: 20px"
                />

                <div class="d-flex justify-content-end" v-else>
                    <button class="btn btn-primary ms-2 mb-2" @click="openServiceLocationForm()">
                        Add Service Location
                    </button>
                </div>

                <Pagination ref="serviceLocationList" :page-changed="pageChangedCallback" :is-loading="isLoading">
                    <table class="table table-responsive-md border border-gray">
                        <thead>
                            <tr class="bg-table-header">
                                <th>Service Location <span class="text-danger">*</span></th>
                                <th>Date</th>
                                <th>Time</th>
                                <th class="text-end">Actions</th>
                            </tr>
                        </thead>
                        <tbody v-if="isLoading || isError || !hasData">
                            <!-- LOADING -->
                            <tr v-for="i of loadingCount" class="table-loading" v-if="isLoading">
                                <td v-for="i of columns">
                                    <span class="shimmer-loading"></span>
                                </td>
                            </tr>
                            <!-- EMPTY -->
                            <tr class="table-empty" v-if="!isLoading && !isError && !hasData">
                                <td :colspan="columns">
                                    <h3>No Service Locations</h3>
                                </td>
                            </tr>
                            <!-- ERROR -->
                            <tr class="table-error" v-if="!isLoading && isError">
                                <td :colspan="columns">
                                    <ErrorMessageHandler title="Service Location" :try-again="resetList" />
                                </td>
                            </tr>
                        </tbody>
                        <template v-else>
                            <ServiceLocationRow
                                v-for="service of page.items"
                                :key="service.Id"
                                :service="service"
                                :columns="columns"
                                :reset-list="resetList"
                            />
                        </template>
                    </table>
                </Pagination>
            </div>
        </template>
    </FormSection>
</template>

<script src="./ServiceLocations.ts"></script>
